import NotificationApi from '@/api/Notification/api'

export default {
  methods: {
    async getNotification ({notificationType, instanceId}) {
      try {
        const resp = await NotificationApi.getNotifications({notificationType, instanceId})
        return resp.data
      } catch (e) {
        console.error(e)
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getNotification.js